export function intToTheme(value){
    if (value){
        value = parseInt(value)
    }
    return value ? 'dark': 'light';
}

export function themeToInt(theme){
    return theme == 'dark' ? 1 : 0;
}

export function switchTheme(theme){
    return theme == 'light' ? 'dark' : 'light';
}